import React from 'react';
import { Button } from '../../../components/ui/button';

/**
 * Footer for paged lists: Previous / "Page X of Y (N total)" / Next.
 * `page` is 0-based (as the API expects).
 */
export const OTRPagination = ({
  page = 0,
  totalPages = 1,
  totalElements = 0,
  onPageChange,
  disabled = false,
}) => {
  if (!totalElements) return null;

  const lastPage = Math.max(totalPages - 1, 0);
  const navClass =
    'h-9 px-3 rounded-lg border border-[var(--color-text-border)] text-xs hover:bg-[var(--color-workspace)] bg-white text-foreground';

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 sm:px-6 py-4 border-t border-[var(--color-text-border)]/50">
      <Button
        onClick={() => onPageChange(page - 1)}
        disabled={disabled || page <= 0}
        className={navClass}
      >
        Previous
      </Button>

      <span className="text-xs text-[var(--color-text-secondary)]">
        Page {page + 1} of {Math.max(totalPages, 1)} ({totalElements} total)
      </span>

      <Button
        onClick={() => onPageChange(page + 1)}
        disabled={disabled || page >= lastPage}
        className={navClass}
      >
        Next
      </Button>
    </div>
  );
};